import { useMutation } from '@tanstack/react-query';
import { queryFetch } from '@services/api';
import { CreateInternalMultischeduleReq, CreateInternalScheduleMultiDayReq } from './types';
import { useJobRefetch } from '@hooks/job/refetch';
import { DefaultApiResp } from '@root/globalTypes';
import { camelToSnakeCase } from '@utils/textHelpers';

export const useCreateInternalMultischedule = ({
  callback,
}: {
  callback: (data: DefaultApiResp) => void;
}) => {
  const { refetch } = useJobRefetch({ schedule: { type: 'internal', action: 'create' } });

  const { mutate, isPending } = useMutation({
    mutationFn: ({
      ...data
    }:
      | CreateInternalMultischeduleReq
      | CreateInternalScheduleMultiDayReq): Promise<DefaultApiResp> => {
      const crewChangeScope = 'crewChangeScope' in data ? data.crewChangeScope : undefined;
      return queryFetch({
        url: 'internal_multischedules',
        data: {
          ...data,
          ...(crewChangeScope && { crewChangeScope: camelToSnakeCase(crewChangeScope) }),
        } as unknown as Record<string, unknown>,
        opt: { method: 'POST' },
      });
    },
    onError: (err) => {
      console.error(err);
    },
    onSuccess: async ({ success }) => {
      if (!success) return;
      await refetch();
    },
    onSettled: (data) => {
      if (data) callback(data);
    },
  });

  return {
    mutate,
    isLoading: isPending,
  };
};
